import { library } from "@fortawesome/fontawesome-svg-core";

/**
 * Register Application specific Font Awesome icons
 */
import { faArchive, faCode } from "@fortawesome/free-solid-svg-icons";
library.add(faArchive, faCode);
